function Admin() {
  window.location.href = process.env.REACT_APP_ADMIN_URI;
  return null;
}

export default Admin;
